import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Bar } from 'react-chartjs-2';
import { Typography, CircularProgress } from '@material-ui/core';
import energyIco from '../../assets/icons/energy.png';
import * as stnFastDataReducer from '../../station-fastdata/reducer';
import * as liveStationReducers from '../reducer';

const energyData = {
    labels: [],
    datasets: [
        {
            label: 'Real-time Energy Meter',
            backgroundColor: '#59C1BD',
            borderColor: '',
            borderWidth: 0.5,
            hoverBackgroundColor: 'rgba(52, 58, 64, 0.5)',
            data: [],
        }
    ],
};

const chartOption = {
    scales: {
        yAxes: [{
            scaleLabel: {
                display: true,
                labelString: 'kWhr'
            },
            ticks: {
                beginAtZero: true
            }
        }],
        xAxes: [{
            barPercentage: 0.3,
            gridLines: {
                display: false
            }
        }]
    }
};

class EnergyMeterInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        };
        this.handle_stn_fastdata = this.handle_stn_fastdata.bind(this);
    }

    handle_stn_fastdata() {
        const { history } = this.props;
        history.push(`/station-fastdata`);
    }

    componentDidUpdate(prevProps) {
        const { getRealtimeEnergy, getLastFastData } = this.props;

        if (getRealtimeEnergy !== prevProps.getRealtimeEnergy || getLastFastData !== prevProps.getLastFastData) {
            if (getRealtimeEnergy !== "" && getLastFastData !== null && getLastFastData.Data) {
                this.setState({ loading: false });
                this.updateEnergyInfo();
            } else {
                this.setState({ loading: true });
            }
        }
    }

    updateEnergyInfo() {
        const { getRealtimeEnergy, getLastFastData } = this.props;
        const gradient = this.getGradient();
        const reltimeEnergy = [];
        const finalData = [];
        const energyLabels = [];

        if (getRealtimeEnergy !== "" && getLastFastData !== null && getLastFastData.Data) {
            const arr_string = getRealtimeEnergy.split(",");
            const energyMap = {};

            arr_string.forEach((item, idx) => {
                const [index, name] = item.split(':');
                energyMap[index] = name || `Energy Meter ${idx + 1}`;
                energyLabels.push(energyMap[index]);
                reltimeEnergy.push(getLastFastData.Data[index]);
            });

            if (reltimeEnergy.filter(energy => energy > 100000).length > 0) {
                reltimeEnergy.forEach(val => finalData.push(val / 10000));
                chartOption.scales.yAxes[0].scaleLabel.labelString = "MWh";
            } else {
                reltimeEnergy.forEach(val => finalData.push(val / 10));
            }

            energyData.labels = energyLabels;
            energyData.datasets[0].data = finalData;
            energyData.datasets[0].backgroundColor = gradient;
        }
    }

    getGradient() {
        const ctx = document.createElement('canvas').getContext('2d');
        const gradient = ctx.createLinearGradient(0, 0, 0, 400);
        gradient.addColorStop(0, '#59C1BD');
        gradient.addColorStop(1, '#3E54AC');
        return gradient;
    }

    render() {
        const { loading } = this.state;
        const { getRealtimeEnergy } = this.props;

        return (
            <div style={{ padding: '15px', cursor: 'pointer' }} onClick={this.handle_stn_fastdata}>
                {loading ? (
                    <div className="loadingWrapper">
                        <div className="loading">
                            <CircularProgress />
                            <Typography variant="h6">Loading...</Typography>
                        </div>
                    </div>
                ) : getRealtimeEnergy === '-1' ? (
                    <div style={{ padding: '18px' }}>
                        <div style={{ textAlign: 'center' }}>
                            <img src={energyIco} width={100} alt="icon" />
                        </div>
                        <Typography variant="h6" style={{ textAlign: 'center', fontWeight: '400', marginTop: '15px' }}>
                            No Energy Meter Available
                        </Typography>
                    </div>
                ) : (
                    <>
                        <Bar data={energyData} options={chartOption} />
                    </>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    getRealtimeEnergy: stnFastDataReducer.getRealtimeEnergy(state),
    getLastFastData: liveStationReducers.getLastFastData(state),
    getFindStationRealtimeFields: stnFastDataReducer.getFindStationRealtimeFields(state),
});

export default connect(mapStateToProps)(withRouter(EnergyMeterInfo));
